"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class OrbiterError extends Error {
    constructor(descriptor, message) {
        super(message);
        this.descriptor = descriptor;
    }
    isDescriptor(descriptor) {
        return this.descriptor === descriptor;
    }
    is(e) {
        return this.isDescriptor(e.getDescriptor());
    }
    getDescriptor() {
        return this.descriptor;
    }
}
exports.OrbiterError = OrbiterError;
class OrbiterErrorCatcher {
    constructor() {
        this.eavesdroppers = [];
        this.listeners = new Map();
        this.lastResortCatcher = null;
    }
    catchError(e) {
        this.eavesdroppers.forEach((ed) => {
            try {
                ed(e);
            }
            catch (_a) { }
        });
        if (e instanceof OrbiterError) {
            if (this.listeners.has(e.getDescriptor())) {
                return this.listeners.get(e.getDescriptor())(e);
            }
        }
        if (this.lastResortCatcher !== null) {
            return this.lastResortCatcher(e);
        }
    }
    addCatcher(e, f) {
        this.listeners.set(e.getDescriptor(), f);
        return this;
    }
    addEavesdropper(f) {
        this.eavesdroppers.push(f);
        return this;
    }
    /**
     * This function will be called when no matching catcher is found.
     *
     * @param {Function} f
     * @returns {OrbiterErrorCatcher}
     */
    setLastResortCatcher(f) {
        this.lastResortCatcher = f;
        return this;
    }
}
exports.OrbiterErrorCatcher = OrbiterErrorCatcher;
exports.LANGUAGE_EXCEPTION = new OrbiterError("ORBITER_LANGUAGE_EXCEPTION");
exports.ID_EXCEPTION = new OrbiterError("ORBITER_ID_EXCEPTION");
exports.INVALID_DATE_EXCEPTION = new OrbiterError("ORBITER_INVALID_DATE_EXCEPTION");
exports.NOT_FOUND_EXCEPTION = new OrbiterError("ORBITER_NOT_FOUND_EXCEPTION");
exports.EMAIL_EXCEPTION = new OrbiterError("ORBITER_EMAIL_EXCEPTION");
exports.UPDATE_EXCEPTION = new OrbiterError("ORBITER_UPDATE_EXCEPTION");
exports.EXECUTION_EXCEPTION = new OrbiterError("ORBITER_EXECUTION_EXCEPTION");
exports.PARAMETER_EXCEPTION = new OrbiterError("ORBITER_PARAMETER_EXCEPTION");
exports.KEY_EXCEPTION = new OrbiterError("ORBITER_KEY_EXCEPTION");
exports.VALUE_EXCEPTION = new OrbiterError("ORBITER_VALUE_EXCEPTION");
exports.PATH_EXCEPTION = new OrbiterError("ORBITER_PATH_EXCEPTION");
exports.CREATION_EXCEPTION = new OrbiterError("ORBITER_CREATION_EXCEPTION");
exports.AUTHENTICATION_EXCEPTION = new OrbiterError("ORBITER_AUTHENTICATION_EXCEPTION");
exports.NOT_IMPLEMENTED_EXCEPTION = new OrbiterError("ORBITER_NOT_IMPLEMENTED_EXCEPTION");
exports.ADDRESS_EXCEPTION = new OrbiterError("ORBITER_ADDRESS_EXCEPTION");
//# sourceMappingURL=exceptions.js.map